export const filterToolFocus = (toolFocusOptions) => {
    let diversityFocusOptions = [], relevantForOptions = []; 
    // console.log(toolFocusOptions)
    for(let filter of toolFocusOptions) {
      // console.log(filter)
        if(filter._id === "1") {
          for(let option of filter.filterValues) {
           diversityFocusOptions.push({...option})
          }
         let diversityTagFoucs = {key: 'otherDiversityFocus', focus: 'Other', type: 'diversityFocusTag'}
         diversityFocusOptions = [...diversityFocusOptions, {...diversityTagFoucs}];
        } else if (filter._id === "2") {
           for(let option of filter.filterValues) {
             relevantForOptions.push({...option})
           }
           let relevantForTagFoucs = {key: 'otherRelevantFor', focus: 'Other', type: 'relevantForTag'};
           relevantForOptions = [...relevantForOptions, {...relevantForTagFoucs}];
        }
   }
   return {diversityFocusOptions, relevantForOptions};
  }